module.exports = __webpack_public_path__ + "assets/settings.c157db72.svg";